import { useContext } from 'react';
import { ExploreContext } from '../explore-context-provider';

export function useExploreContext() {
    return useContext(ExploreContext);
}
